import styled from 'styled-components';

export const SocialBarContainer = styled.div`
  height: 44px !important;
  clear: both;

  .sprite {
    height: 20px !important;
    clear: both;
  }
  .iconList {
    height: 24px !important;
  }
  button {
    margin: 0 8px 0 0;
    padding: 0;
    width: 24px !important;
    height: 24px !important;
    cursor: pointer;
    background: transparent !important;
  }
  &.rtl {
    button {
      margin: 0 0 0 8px;
    }
  }
  .copyLink,
  .facebook,
  .twitter,
  .linkedin {
    background: transparent !important;
    border: 0 !important;
    outline: none !important;
    cursor: pointer !important;
    height: 24px !important;
    display: inline-block;
  }
`;
